import { render, staticRenderFns } from "./FollowUpCommLog.vue?vue&type=template&id=1f7d9fd3&scoped=true&"
import script from "./FollowUpCommLog.vue?vue&type=script&lang=js&"
export * from "./FollowUpCommLog.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpCommLog.vue?vue&type=style&index=0&id=1f7d9fd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7d9fd3",
  null
  
)

export default component.exports